import { isNil } from 'lodash'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { FeeMethod } from '@eastcoal/shared/enums/FeeMethod'

export const serviceFeeValidator: SchemaItem['x-validator'] = {
  validator(value: { serviceFeeMethod: FeeMethod; serviceFeeValue?: number }) {
    if (
      value.serviceFeeMethod === FeeMethod.NONE ||
      value.serviceFeeMethod === FeeMethod.GRADIENT
    ) {
      return null
    }

    if (isNil(value.serviceFeeValue)) {
      return '服务费值不能为空'
    }

    if (value.serviceFeeValue <= 0) {
      return '服务费值必须大于0'
    }

    return null
  }
}
